const formatSubtractingPrice = (price) =>
  `$${(+price.toFixed(2)).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`.replace("$-", "$");

export default formatSubtractingPrice;
